module.exports = __webpack_public_path__ + "img/gsjj.8ffded17.png";